var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,7.3c-0.2-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.6-0.5-1-0.7c-0.4-0.2-0.8-0.2-1.2-0.2c-0.6,0-1.1,0.2-1.6,0.5 C10.2,6,10.1,6.1,10,6.2C9.9,6.1,9.8,6,9.7,5.9C9.2,5.6,8.6,5.5,8,5.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-1,0.7 C5.6,6.6,5.3,7,5.2,7.3C5,7.7,4.9,8.1,4.9,8.5c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.3,0.7,0.6,1.1c0.4,0.6,0.9,1.2,1.6,1.8 c1.1,1,2.2,1.7,2.2,1.7l0.3,0.2c0.1,0.1,0.3,0.1,0.4,0l0.3-0.2c0,0,1.1-0.7,2.2-1.7c0.7-0.6,1.2-1.2,1.6-1.8 c0.2-0.4,0.4-0.7,0.6-1.1c0.2-0.4,0.2-0.8,0.2-1.2C15.1,8.1,15,7.7,14.8,7.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c107f9f7cbdc31931b2e37b0d97081ce.svg";
export { ForwardRef as ReactComponent };